import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { handleAuthRedirectIfNeeded } from './auth';
import ErrorBoundary from './ErrorBoundary';

global.apiUrl = process.env.REACT_APP_API_URL || "https://api-prod.valueguard.se";

console.log('BOOT', {
    REACT_APP_AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
    REACT_APP_AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
    REACT_APP_AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
});

(async () => {
    try {
        await handleAuthRedirectIfNeeded();
    } catch (e) {
        console.error('handleAuthRedirectIfNeeded failed:', e);
    } finally {
        ReactDOM.render(
            <ErrorBoundary>
                <App />
            </ErrorBoundary>,
            document.getElementById('root')
        );
    }
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
